import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=a514ea64&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=a514ea64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a514ea64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a514ea64')) {
      api.createRecord('a514ea64', component.options)
    } else {
      api.reload('a514ea64', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=a514ea64&scoped=true&", function () {
      api.rerender('a514ea64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/visit_manage/dealer_visit_detail/components/detail.vue"
export default component.exports